import React, { useState } from 'react';
import { H2, Body1 } from '../../themes/typography';
import '../../styles/components/HowItWorks.css';
import Cta from '../Buttons/Cta.jsx';
import HowItWorks1 from '../../assets/images/HowItWorks1.svg';
// import HowItWorks2 from '../../assets/images/HowItWorks2.svg';
import HowItWorks3 from '../../assets/images/HowItWorks3.svg';
import HowItWorks4 from '../../assets/images/HowItWorks4.svg';
import HowItWorks5 from '../../assets/images/HowItWorks5.svg';
import HowItWorks6 from '../../assets/images/HowItWorks6.svg';
import HowItWorks7 from '../../assets/images/HowItWorks7.svg';
import HowItWorks8 from '../../assets/images/HowItWorks8.svg';
import HowItWorks9 from '../../assets/images/HowItWorks9.svg';
import HowItWorks10 from '../../assets/images/HowItWorks10.svg';

export default function HowItWorks() {
    // State to track the active section ('attendees' or 'eventCreators' or 'venues')
    const [activeSection, setActiveSection] = useState('attendees');

    // Function to handle section toggle
    function handleSectionToggle(section) {
        setActiveSection(section);
    }

    // Data for attendee steps
    const attendeeSteps = [
        {
            image: HowItWorks1,
            text: 'Discover events & venues for your choice of outing'
        },
        {
            image: HowItWorks10,
            text: 'Effortlessly book tickets & venues'
        },
        {
            image: HowItWorks3,
            text: 'Enjoy your outing & make memories'
        }
    ];

    // Data for organizer steps
    const organizerSteps = [
        {
            image: HowItWorks4,
            text: 'Simply add event details to the platform & start organizing your perfect event'
        },
        {
            image: HowItWorks5,
            text: 'Discover & book venues that match your event needs, all in one place'
        },
        {
            image: HowItWorks6,
            text: 'Set ticketing options, publish & promote your event to attract attendees effortlessly'
        }
    ];

    // Data for venues steps

    const venuesSteps = [
        {
            image: HowItWorks7,
            text: 'Register and get onboarded with shmooz!'
        },
        {
            image: HowItWorks8,
            text: 'Simply list your venue details and Go Live!'
        },
        {
            image: HowItWorks9,
            text: 'Manage bookings  and create events to promote your venue'
        }
    ];

    // Function to render steps based on provided data
    const renderSteps = (steps) => {
        return steps.map((step, index) => (
            <div key={index} className="how-it-works-steps">
                <div className="how-it-works-steps-image">
                    <img src={step.image} alt={`HowItWorks${index + 1}`} />
                </div>
                <div className="how-it-works-steps-content">
                    <Body1 color="#F8A21E">{step.text}</Body1>
                </div>
            </div>
        ));
    };

    return (
        <div className="how-it-works-container">
            <div className="how-it-works-heading-section">
                <H2 color="#F8A21E">How it Works</H2>
            </div>

            <div className="how-it-works-toggle-section-container">
                <div className="how-it-works-toggle-section">
                    {/* Button for Attendees, toggles active section */}
                    <Cta
                        name="For Attendees"
                        onClick={() => handleSectionToggle('attendees')}
                        transparent={activeSection !== 'attendees'}
                    />
                    {/* Button for Organizers, toggles active section */}
                    <Cta
                        name="For Event Creators"
                        onClick={() => handleSectionToggle('eventCreators')}
                        transparent={activeSection !== 'eventCreators'}
                    />
                    {/* Button for Organizers, toggles active section */}
                    <Cta
                        name="For Venues"
                        onClick={() => handleSectionToggle('venues')}
                        transparent={activeSection !== 'venues'}
                    />
                </div>

                <div className="how-it-works-content-section">
                    <div className="how-it-works-toggle-data-section">
                        {/* Render steps based on the active section */}
                        {activeSection === 'attendees' && renderSteps(attendeeSteps)}
                        {activeSection === 'eventCreators' && renderSteps(organizerSteps)}
                        {activeSection === 'venues' && renderSteps(venuesSteps)}
                    </div>
                </div>
            </div>
        </div>
    );
}
